<section *ngIf="!isSaving">
  <div class="p-grid cre-commitment-daily-5">
    <div class="p-col-12 cre-question">
      1. When is the next pickup/drop appointment on your current dispatch?
    </div>
    <div class="p-field p-col-12 p-sm-6 p-md-4 p-lg-2 cre-question-answer">
      <p-calendar
        #appt
        readonlyInput="true"
        appendTo="body"
        class="calendar"
        dateFormat="mm-dd-yy"
        hourFormat="24"
        [(ngModel)]="model.appt"
        placeholder="MM-DD-YYYY HH:MM"
        [showIcon]="true"
        [showTime]="true"
      >
        <p-footer class="calendar-footer">
          <button (click)="appt.hideOverlay()" label="Close" pButton type="button"></button>
        </p-footer>
      </p-calendar>
    </div>
    <div class="p-col-12 cre-question">
      2. Are you running on-time to your trip plan?
    </div>
    <div class="p-col-2 p-md-1 p-lg-1 cre-question-answer">
      <p-radioButton
        class="form-control"
        [disabled]="false"
        label="Yes"
        name="runningOnTime"
        [(ngModel)]="model.runningOnTime"
        required="true"
        value="Y"
      >
      </p-radioButton>
    </div>
    <div class="p-col-2 p-md-1 p-lg-1 cre-question-answer">
      <p-radioButton
        class="form-control"
        [disabled]="false"
        label="No"
        name="runningOnTime"
        [(ngModel)]="model.runningOnTime"
        required="true"
        value="N"
      >
      </p-radioButton>
    </div>
    <div class="p-col-12 cre-question">
      3. What is your estimated time of arrival (ETA) to your next pickup/drop?
    </div>
    <div class="p-field p-col-12 p-sm-6 p-md-4 p-lg-2 cre-question-answer">
      <p-calendar
        #eta
        readonlyInput="true"
        appendTo="body"
        class="calendar"
        dateFormat="mm-dd-yy"
        hourFormat="24"
        [(ngModel)]="model.eta"
        placeholder="MM-DD-YYYY HH:MM"
        [showIcon]="true"
        [showTime]="true"
      >
        <p-footer class="calendar-footer">
          <button (click)="eta.hideOverlay()" label="Close" pButton type="button"></button>
        </p-footer>
      </p-calendar>
    </div>
    <div class="p-col-12 cre-question">
      4. What is your projected time of availability (PTA) when you’ll be ready for your reload?
    </div>
    <div class="p-field p-col-12 p-sm-6 p-md-4 p-lg-2 cre-question-answer">
      <p-calendar
        #pta
        readonlyInput="true"
        appendTo="body"
        class="calendar"
        dateFormat="mm-dd-yy"
        hourFormat="24"
        [(ngModel)]="model.pta"
        placeholder="MM-DD-YYYY HH:MM"
        [showIcon]="true"
        [showTime]="true"
      >
        <p-footer class="calendar-footer">
          <button (click)="pta.hideOverlay()" label="Close" pButton type="button"></button>
        </p-footer>
      </p-calendar>
    </div>
    <div class="p-col-12 cre-question">
      5. How many days drive hours do you have available for the next three days?
    </div>
    <div class="p-field p-col-12 cre-question-answer">
      <div class="p-grid">
        <div class="p-col-4">
          <input
            class="p-col-12 day-hours"
            [(ngModel)]="model.hoursPerDay.day1"
            pInputText
            placeholder="Day 1"
            type="number"
          />
        </div>
        <div class="p-col-4">
          <input
            class="p-col-12 day-hours"
            [(ngModel)]="model.hoursPerDay.day2"
            pInputText
            placeholder="Day 2"
            type="number"
          />
        </div>
        <div class="p-col-4">
          <input
            class="p-col-12 day-hours"
            [(ngModel)]="model.hoursPerDay.day3"
            pInputText
            placeholder="Day 3"
            type="number"
          />
        </div>
      </div>
    </div>
    <p-messages [(value)]="model.errors"></p-messages>
    <div class="p-field p-col-12">
      <p-button
        class="submit-btn"
        [disabled]="!model.isValid()"
        label="Submit"
        (onClick)="submitDaily5()"
      ></p-button>
    </div>
  </div>
</section>
<div class="p-grid p-justify-center">
  <cre-spinner [size]="'md'" [hidden]="!isSaving"></cre-spinner>
</div>
